import Error from "../Component/UserEnd/Error";
import Footer from "../Component/UserEnd/Footer";

function ErrorPage() {
    return (
        <>
            <Error />
            <Footer />
        </>
    );
}

export default ErrorPage;
